<ng-template #modalPreviewPortal>
    <div class="modal-preview">
        <div class="modal-wrapper">
            <web-product-card-modal [classes]="classes" [data]="data"></web-product-card-modal>
        </div>
    </div>
</ng-template>

<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "widget_product_modal_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <web-general-settings
            [generalSettingsFormGroup]="generalSettingsFormGroup"
            [isModalSettings]="true"
        ></web-general-settings>
        <web-typography-settings [typographySettingsFormGroup]="typographySettingsFormGroup"></web-typography-settings>
        <web-product-variants-settings
            [productVariantsSettingsFormGroup]="productVariantsSettingsFormGroup"
        ></web-product-variants-settings>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
